
    import {defineComponent, h, reactive} from 'vue'
    import {useRoute} from "vue-router";
    import {useStore} from '@/store'
    import {GetReportViewModelFromJSON, GetReportViewModelFromServe, GetVerifyEffectiveReport, GetOldReportPdfUrl, GetCheKuangReportUrl} from '@/service'

    let nameList = [
        // 'SwiperBanner',
        // '268VTip',
        // 'CarNameVin',
        'navigation',
        'HeadTip',
        'ReportMain',
        'CarNameVin',
        'Entrust',
        'BaseInfo',
        'ConfigurationInfo',
        'AccidentLCheck',
        'FireCheck',
        'WaterCheck',
        'AppearanceCheck',
        'InteriorCheck',
        'LightingCheck',
        'EngineRoomCheck',
        'PowerCheck',
        'ChassisCheck',
        'StartUpCheck',
        'EcuCheck',
        'AttachPhoto',
        'RemarksMsg',
        'detectMsg',
        'EnsureService',
        'ReminderText',
    ]
    let list: any[] = [];
    let components = {};
    nameList.forEach(item => {
        if (!components[item]) {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const model = require(`./_components/${item}.vue`)['default'];
            list.push(model)
            components[item] = model
        } else {
            list.push(components[item])
        }
    });
    interface State {
        reportLevel: number;
        reportCode: any;
        templateCode: any;
    }
    export default defineComponent({
        name: "h5_index",
        components,
        setup() {
            let state: State = reactive({
                reportLevel: 0,
                reportCode: '',
                templateCode: '',
            })
            
            document.title="检测认证评估报告"
            const {query} = useRoute();
            const {reportCode, reportLevel, templateCode} = query
            state.reportLevel = Number(reportLevel) || 0;
            state.reportCode = reportCode || '';
            state.templateCode = templateCode || '';
            let store = useStore()
            // let time = 0;
            // if (reportCode && typeof reportCode === 'string') {
            //     time = Number(reportCode.substring(2));
            // }
            // const batTime = 230525183151001;
            // console.log('cccccccccc');
            // if (time<batTime) {
            //     // GetReportViewModelFromServe({reportCode, reportLevel, templateCode}).then((res: any) => {
            //     //     store.dispatch('saveDataInfo', res)
            //     // }).catch((err) => {
            //     //     console.error(err)
            //     // })
            //     window.location.href='https://cheyipai-i-ali-268v.oss-cn-beijing.aliyuncs.com/screenshot-22-20230523-182845-207-1a78f.pdf';
            // } else {
                GetReportViewModelFromJSON({reportCode}).then((res: any) => {
                    store.dispatch('saveDataInfo', res)
                }).catch((err) => {
                    if (err.message.indexOf('404')) {
                        // json文件404了请求直连接口
                        GetReportViewModelFromServe({reportCode, reportLevel, templateCode}).then((res: any) => {
                            store.dispatch('saveDataInfo', res)
                        }).catch((err) => {
                            console.error(err)
                        })
                    } else {
                        console.error(err)
                    }
                })
            // }
            // 直链接口
            // GetReportViewModelFromServe({reportCode, reportLevel, templateCode}).then((res: any) => {
            //     store.dispatch('saveDataInfo', res)
            // }).catch((err) => {
            //     // eslint-disable-next-line
            //     console.error(err)
            // })
            // 先尝试json文件
            
            return {
                state
            }
        },
        render() {
            return h('div', {class: this.state.reportLevel === 4 ? 'main__bg_color1' : 'main__bg_color'}, list.map((item, index) =>
                h(item, {}, index)
            ));
        },
        beforeRouteEnter(to, from, next) {
            const {reportCode, reportVersion, templateCode, targetPage} = to.query;
            let time = 0;
            if (reportCode && typeof reportCode === 'string') {
                time = Number(reportCode.substring(2));
            }
            const batTime = 230525183151001;
            function jumpToChekuang() {
                if (!templateCode) {
                    to.query.templateCode = 'no_cert_report';
                }
                if(`${reportCode}`.indexOf('DE') > -1) {
                    let url = '';
                    GetCheKuangReportUrl({reportCode, templateCode}).then((res: any) => {
                        url = res;
                        if (url) {
                            window.location.href = url;
                        } else {
                            next();
                        }
                    }).catch(() => {
                        next();
                    });
                } else {
                    next();
                }
            }
            function jump() {
                if (reportVersion && reportVersion === 'tocv002') {
                    next({
                        path: '/toc',
                        query: to.query
                     })
                }
                if (reportVersion && reportVersion === 'tocv003') {
                     next({
                        path: '/tocV3',
                        query: to.query
                     })
                }
                if (reportVersion && reportVersion === 'tocv004') {
                     next({
                        path: '/tocV4',
                        query: to.query
                     })
                }
                
                if(`${reportCode}`.indexOf('DE') > -1) {
                    let isClose = true;
                    GetVerifyEffectiveReport({reportCode}).then((res: any) => {
                        isClose = res;
                        if (!isClose) {
                            next('/deffectiveReport')
                        } else {
                            jumpToChekuang();
                        }
                    }).catch(() => {
                        next();
                    });
                } else {
                    next();
                }
            }
            if (time<batTime && !targetPage) {
                console.log('cccccccccc');
                let opt = {
                    reportCode,
                    reportVersion,
                    templateCode
                };
                GetOldReportPdfUrl(opt).then((res: any) => {
                    if (res) {
                        next({
                            path: '/viewPDF',
                            query: {
                                'pdfurl': encodeURIComponent(res)
                            }
                        })
                    } else {
                        jump();
                    }
                });
            } else {
                jump();
            }
        }
    });
